import React, { useState } from "react";
import { Brain, Shield, Bot, Lightbulb, ArrowRight } from "lucide-react";

const MethodologySection = () => {
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    {
      number: "01",
      icon: <Brain className="step-icon" />,
      title: "Pensamiento Crítico",
      description: "Aprenden a analizar, cuestionar y resolver problemas complejos.",
      details: "Los estudiantes aprenden a descomponer problemas, evaluar información y tomar decisiones fundamentadas."
    },
    {
      number: "02", 
      icon: <Shield className="step-icon" />,
      title: "Ciberseguridad",
      description: "Desarrollan hábitos digitales seguros y responsables.",
      details: "Desde passwords seguros hasta reconocer amenazas online, preparamos ciudadanos digitales responsables."
    },
    {
      number: "03",
      icon: <Bot className="step-icon" />,
      title: "Consciencia de IA",
      description: "Entienden cómo funciona la inteligencia artificial y cómo usarla éticamente.",
      details: "Exploramos herramientas de IA, sus limitaciones y su impacto en la sociedad del futuro."
    },
    {
      number: "04",
      icon: <Lightbulb className="step-icon" />,
      title: "Innovación",
      description: "Aplicanlo aprendido en proyectos reales con impacto positivo.",
      details: "Los estudiantes crean soluciones originales para problemas reales de su comunidad."
    }
  ];

  return (
    <section className="methodology-section" id="methodology">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">
            Nuestra metodología basada en
            <span className="title-highlight"> Aventuras y Proyectos</span>
          </h2>
          <p className="section-subtitle">
            Un camino estructurado que transforma niños curiosos en creadores seguros y pensadores críticos.
          </p>
        </div>
        
        <div className="methodology-roadmap">
          <div className="roadmap-vertical">
            {steps.map((step, index) => (
              <div 
                key={index}
                className={`roadmap-step-vertical ${activeStep === index ? 'active' : ''}`}
                onMouseEnter={() => setActiveStep(index)}
              >
                <div className="step-connector-vertical">
                  {index < steps.length - 1 && (
                    <div className="connector-line-vertical">
                      <div className="neon-particles">
                        <div className="particle particle-1"></div>
                        <div className="particle particle-2"></div>
                        <div className="particle particle-3"></div>
                      </div>
                    </div>
                  )}
                </div>
                
                <div className="step-content-vertical">
                  <div className="step-number-vertical">{step.number}</div>
                  <div className="step-icon-container-vertical">
                    {step.icon}
                  </div>
                  <div className="step-text">
                    <h3 className="step-title-vertical">{step.title}</h3>
                    <p className="step-description-vertical">{step.description}</p>
                  </div>
                </div>
                
                <div className="step-glow-vertical"></div>
              </div>
            ))}
          </div>
          
          <div className="roadmap-details-vertical">
            <div className="active-step-details-vertical">
              <h4 className="details-title-vertical">{steps[activeStep].title}</h4>
              <p className="details-description-vertical">{steps[activeStep].details}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MethodologySection;